
import { component } from '@/helpers/vueTyped';
import { dispatch } from '@/store';

interface ExitDialogProps {
  closedCallback: () => void;
}

export default component<ExitDialogProps>()({
  name: 'ExitDialog',

  props: {
    closedCallback: {},
  },

  methods: {
    exit() {
      window.location.href = 'about:blank';
    },

    handleLeftNavigation() {
      return document.activeElement === (this.$refs.yes as HTMLElement);
    },

    handleRightNavigation() {
      return document.activeElement === (this.$refs.no as HTMLElement);
    },
  },

  mounted() {
    dispatch('setMainBlurred', [true]);

    (this.$refs.yes as HTMLElement).focus();
  },

  created() {
    this.$spatialFocus.pushGlobalOverride('back', this.closedCallback);
    this.$spatialFocus.pushGlobalOverride('up', () => true);
    this.$spatialFocus.pushGlobalOverride('down', () => true);
    this.$spatialFocus.pushGlobalOverride('left', this.handleLeftNavigation);
    this.$spatialFocus.pushGlobalOverride('right', this.handleRightNavigation);
  },

  destroyed() {
    dispatch('setMainBlurred', [false]);

    this.$spatialFocus.popGlobalOverride('back');
    this.$spatialFocus.popGlobalOverride('up');
    this.$spatialFocus.popGlobalOverride('down');
    this.$spatialFocus.popGlobalOverride('left');
    this.$spatialFocus.popGlobalOverride('right');
  },

  render(h) {
    return (
      <div class='background'>
        <div class='dialog'>
          <div class='title'>
            {'Are you sure you want to exit?'}
          </div>

          <div
            class='options'
            v-spatial-container='dialog-options'
          >
            <div class='option' onClick={this.exit} ref='yes'>{'Yes'}</div>
            <div class='option' onClick={this.closedCallback} ref='no'>{'No'}</div>
          </div>
        </div>
      </div>
    );
  },
});

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-c6577f2e/ExitDialog.vue" });